module.exports = __webpack_public_path__ + "static/img/iconSearchHand.459602d.png";